<!-- 嵌入式-产品型号管理 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增产品型号
      </el-button>
      <div class="former">
        <el-input
          v-model.trim="former['Name|Number:like']"
          placeholder="名称或型号"
          @keydown.enter.native="onSubmitQuery"
        >
        </el-input
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column prop="Name" label="产品型号名称" width="200" />
      <el-table-column prop="Number" label="产品型号" width="200" />
      <el-table-column prop="SNCode" label="产品SN代码" width="200" />
      <el-table-column prop="Remark" label="说明" />
      <el-table-column width="120" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onShowItem(scope.row)"
            title="详情"
          >
            <i class="fas fa-eye"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>

    <item-form
      v-model="item"
      :visible.sync="itemVisible"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import ItemForm from "./form.vue";

export default {
  components: {
    ItemForm,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        "Name|Number:like": "",
      },
      item: this.getEmptyItem(),
      itemVisible: false,
    };
  },
  mounted() {},
  created() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios
        .get("dci/model/product", {
          params: {
            where: this.former,
            ...this.pager,
            order: ["name", "number", "sn_code"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.itemVisible = true;
    },
    getEmptyItem() {
      return {
        Name: "",
        Number: "",
        SNCode: "",
        Remark: "",
        DciAccessoryModelIDs: [],
        DciAccessoryModels: [],
      };
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onShowItem(row) {
      this.item = row;
      this.itemVisible = true;
    },
    onDeleteItem(row) {
      this.$confirm("确定要删除此产品型号吗？", "提示")
        .then(() => this.$axios.delete(`dci/model/product/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("删除成功");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
  },
};
</script>
